import LoginForm from './LoginForm';

export default LoginForm;



// WEBPACK FOOTER //
// ./src/scenes/Login/components/LoginForm/index.ts